export default __webpack_public_path__ + "static/media/avatar_24.db49d5cb.png";